// RFC 4180 CSV escaping: wrap a value in double quotes when it contains a
// comma, double quote, CR, or LF; double-quote any embedded double quotes.
const escapeCsvCell = (value: string | number | boolean | null | undefined): string => {
  if (value === null || value === undefined) {
    return ''
  }
  const str = typeof value === 'string' ? value : String(value)
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export const buildCsv = (headers: string[], rows: Array<Array<string | number | boolean | null>>): string => {
  const headerLine = headers.map(escapeCsvCell).join(',')
  const bodyLines = rows.map((row) => row.map(escapeCsvCell).join(','))
  return [headerLine, ...bodyLines].join('\r\n')
}

const slugify = (input: string): string =>
  input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

const todayIso = (): string => {
  const now = new Date()
  const yyyy = now.getFullYear()
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const dd = String(now.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export const buildCsvFilename = (title?: string): string => {
  const slug = title ? slugify(title) : ''
  const base = slug || 'nexa-results'
  return `${base}-${todayIso()}.csv`
}

// Trigger a UTF-8 CSV download in the browser. Prepends a BOM so Excel
// detects UTF-8 (otherwise it falls back to the system codepage and mangles
// non-ASCII characters).
export const downloadCsv = (filename: string, csv: string): void => {
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}